/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField } from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { ProgramAndEligibility } from './tableHead';

import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { getProgramAndEligibility } from '../Store/action';

const DisplayProgramAndEligibility = () => {
  const {
    displayObj: {
      rebateProgramName: getRebateProgramName,
      startQtr: getQuarter,
      programAndEligibility: getProgramEligibilityList,
    },
  } = useSelector((state) => state?.sharedState?.ProgramEligibilityReducer);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const gridRef = React.useRef();
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [programEligibility, setProgramEligibility] = React.useState();
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [totalAmt, setTotalAmt] = React.useState('');
  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  // program and eligibility api

  React.useEffect(() => {
    // Effect to compute total amount
    let sum = 0;
    const data =
      getProgramEligibilityList?.programAndEligibilityCategoryReportGridVO;

    if (data && Array.isArray(data)) {
      sum = data.reduce((acc, item) => acc + item.amount, 0);
    }

    setTotalAmt(sum);
  }, [getProgramEligibilityList]);

  React.useEffect(() => {
    // Effect to compute percentages based on total amount
    const data =
      getProgramEligibilityList?.programAndEligibilityCategoryReportGridVO;

    if (data && Array.isArray(data)) {
      const newData = data.map((item) => {
        const percentage = totalAmt
          ? (Number(item.amount) / totalAmt) * 100
          : 0;

        return {
          ...item,
          percentage,
          //   amount: item.amount
          //   ? '$' +
          //     item.amount?.toLocaleString('en-US', {
          //       minimumFractionDigits: 2,
          //     })
          //   : '$0.00',
          // percentage,
          // percentage: item.percentage
          //   ? item.percentage?.toLocaleString('en-US', {
          //       minimumFractionDigits: 2,
          //     }) + '%'
          //   : '0.00%',
        };
      });

      setProgramEligibility(newData);
    }
  }, [totalAmt, getProgramEligibilityList]);

  // total QTR
  const value = totalAmt
    ? `$${totalAmt.toLocaleString('en-US', {
        minimumFractionDigits: 2,
      })}`
    : '$0.00';
  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
        amount: parseFloat(item.amount.replace('$', '').replace(/,/g, '')),
        percentage: parseFloat(
          item.percentage.replace('%', '').replace(/,/g, '')
        ),
      };
    });
    setFilteredRow(updatedRowData);
  };
  // pdf header

  const fourthInfo = `QTR Total Invoice Amount : ${value}`;

  const secondInfo = `Quarter: ${getQuarter}`;
  const thirdInfo = `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`;
  // pinned row
  const [displayedRows, setDisplayedRows] = React.useState(
    programEligibility ?? []
  );

  const sum = (property) => {
    const displayedRows =
      filteredRows.length > 0 ? filteredRows : programEligibility;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data).toFixed(2) : '0.00';
  };
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i++) {
      result.push({
        isBottomRow: true,
        groupId: 'Total',
        amount: sum('amount'),
        percentage: sum('percentage'),
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [programEligibility, filteredRows]);
  return (
    <div className="tabs-contaitBillPanel custom-check tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Program and Eligibility Category Report"
      />{' '}
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Rebate_Program"
                        label="Rebate Program"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Rebate_Program' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="QTR Total Invoice Amount "
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        id="QTR_total_invoice_amount"
                        inputProps={{ id: 'QTR_total_invoice_amount' }}
                        value={value}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Quarter "
                        id="Quarterdisp"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Quarterdisp' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={getQuarter}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold">
          <TableGridWithFeatures
            data-testid="program-and-eligibility"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={
              programEligibility // ?.map((item) => {
              // return {
              //   ...item,
              //   amount: item.amount
              //     ? '$' +
              //       item.amount?.toLocaleString('en-US', {
              //         minimumFractionDigits: 2,
              //       })
              //     : '$0.00',

              //   percentage: item.percentage
              //     ? item.percentage?.toLocaleString('en-US', {
              //         minimumFractionDigits: 2,
              //       }) + '%'
              //     : '0.00%',
              // };
              // })
            }
            noGlobalSort
            columnDefs={ProgramAndEligibility}
            exportFile
            animateRows
            sideBar={false}
            fileName="ProgramAndEligibilityCategory "
            reportName="Program and Eligibility Category Report"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onFilterData={onFilterChanged}
            onCellFocused={onCellFocused}
            pinnedBottomRowData={pinnedBottomRowData}
            info={{ fourthInfo, secondInfo, thirdInfo }}
          />
        </div>
      </div>
    </div>
  );
};

export default DisplayProgramAndEligibility;
